module.exports = __webpack_public_path__ + "img/gzh.2cd08c59.jpg";